import type { Guide } from '../types';

/** Address, name, search title and description of the guide in each language (menus, cards, links). */
export const trindadeGuide: Guide = {
  id: 'trindade',
  imageTour: 'jeep-mata-atlantica-15823',
  published: '2026-10-23',
  updated: '2026-10-23',
  tours: ['jeep-mata-atlantica-15823', 'jeep-mata-atlantica'],
  copy: {
    pt: {
      slug: 'trindade-paraty',
      label: 'Trindade',
      title: 'Trindade, Paraty: Praias, Piscina Natural e Como Ir',
      description: 'Trindade, a 30 km de Paraty: Praia do Meio, Cachadaço e a Piscina Natural do Cachadaço. Como ir, dicas e o passeio de dia inteiro saindo de Paraty por {price:jeep-mata-atlantica-15823}.',
    },
    es: {
      slug: 'trindade-paraty',
      label: 'Trindade',
      title: 'Trindade, Paraty: Playas, Piscina Natural y Cómo Ir',
      description: 'Trindade, a 30 km de Paraty: Praia do Meio, Cachadaço y la Piscina Natural do Cachadaço. Cómo ir, consejos y el paseo de día completo desde Paraty por {price:jeep-mata-atlantica-15823}.',
    },
    en: {
      slug: 'trindade-paraty',
      label: 'Trindade',
      title: 'Trindade, Paraty: Beaches, Natural Pool and How to Go',
      description: 'Trindade, 30 km from Paraty: Praia do Meio, Cachadaço and the Cachadaço natural pool. How to get there, tips and a full-day tour from Paraty for {price:jeep-mata-atlantica-15823}.',
    },
    fr: {
      slug: 'trindade-paraty',
      label: 'Trindade',
      title: 'Trindade, Paraty : Plages, Piscine Naturelle et Accès',
      description: 'Trindade, à 30 km de Paraty : Praia do Meio, Cachadaço et la piscine naturelle du Cachadaço. Comment y aller, conseils et excursion d’une journée depuis Paraty pour {price:jeep-mata-atlantica-15823}.',
    },
  },
};
